import { IAuftrag } from '../../types/Types';



interface ThisProps {
  numberToCall: string;
}

/**
 * @author noone
 */
const ButtonCallNumberComponent: React.FC<ThisProps> = (props) => {

  return (
    <>
      <button className="btn btn-light" onClick={ () => window.location.href = "tel:" + props.numberToCall}>
        <i className="bi bi-telephone-fill"></i> Anrufen
      </button>
    </>
  );

}

export default ButtonCallNumberComponent;